import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { OnboardingCard } from "@/components/connect/OnboardingCard";
import { ProductsCard } from "@/components/connect/ProductsCard";
import { HostProCard } from "@/components/connect/HostProCard";

// "Payouts & Store": Stripe Connect sample for hosts (onboarding, products, storefront, Host Pro plan).
export default function HostPayouts() {
  const { user } = useAuth();
  const account = useQuery({
    queryKey: ["connect-account"],
    queryFn: () => api.get("/connect/account").then((r) => r.data),
    enabled: !!user?.is_host,
    retry: false,
  });

  if (!user?.is_host) {
    return (
      <div className="mx-auto mt-16 max-w-xl rounded-3xl border bg-white p-10 text-center" data-testid="payouts-host-only">
        <h1 className="mb-2 text-3xl font-bold">Hosts only</h1>
        <p className="mb-6 text-stone-600">Turn on hosting to connect Stripe and open your store.</p>
        <Button asChild className="rounded-full"><Link to="/host">Go to hosting</Link></Button>
      </div>
    );
  }

  const connected = account.data?.connected;
  return (
    <div className="mx-auto max-w-4xl space-y-6 px-4 py-10 sm:px-6" data-testid="host-payouts-page">
      <Link to="/host" className="inline-flex items-center gap-1 text-sm text-stone-600 hover:text-primary" data-testid="payouts-back-link"><ArrowLeft className="h-4 w-4" />Back to hosting</Link>
      <h1 className="text-4xl font-bold tracking-tight">Payouts &amp; Store</h1>
      <OnboardingCard query={account} />
      {connected && <ProductsCard accountId={account.data.account_id} />}
      {connected && <HostProCard />}
    </div>
  );
}
